// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"d5a0dd19","917":"1582c180"}[chunkId] + ".chunk.js";
};